import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
export function OtlEnvironmental() {
  return <div className="mb-24 grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-328" data-mp="ldem0c0va6cy">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-329" data-mp="q4xumg91mgl1">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-330" data-mp="v6n43rgmam70">
          ¿Qué diferencia a un OTL ambiental?
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed text-sm" data-id="element-331" data-mp="2fve5bq5ats4">
          <p data-id="element-332" data-mp="2hokepwujbzl">
            Un OTL ambiental es una figura territorial legal que está
            relacionada con la conservación, protección, ordenamiento, manejo o
            uso sostenible de los recursos naturales. Su propósito principal es
            ayudar a cuidar ecosistemas estratégicos, fuentes hídricas, áreas
            protegidas, reservas forestales, cuencas y otros espacios de
            importancia ambiental.
          </p>
          <p data-id="element-333" data-mp="tiax80zu77r5">
            La diferencia frente a otros OTL radica en su finalidad y enfoque
            normativo. Mientras algunos objetos pueden estar asociados a temas
            administrativos, catastrales, productivos o de infraestructura, los
            OTL ambientales ponen en el centro la relación entre el espacio
            geográfico delimitado, la naturaleza y las decisiones que garantizan
            su protección y uso responsable.
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} data-id="element-334" data-mp="5soz7gv7aykq">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-335" data-mp="3sz8x09thzqqn">
          Los OTL y el Catastro Multipropósito
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed text-sm" data-id="element-336" data-mp="3ny1q0cz6ivl1">
          <p data-id="element-337" data-mp="3j1b9jojgpxz3">
            Los OTL también son importantes para el Catastro Multipropósito,
            porque permiten relacionar la información ambiental con la
            información predial y territorial. Esto ayuda a comprender mejor las
            condiciones que existen sobre un área o un predio, incluyendo
            posibles derechos, restricciones o responsabilidades.
          </p>
          <p data-id="element-338" data-mp="34em8vjdh5er4">
            Para facilitar este intercambio de información se utiliza{' '}
            <strong className="font-medium text-charcoal" data-id="element-339" data-mp="3s2vscen7tqf3">LADM_COL</strong>, un
            modelo que permite organizar los datos geoespaciales de forma
            estandarizada. Gracias a este lenguaje común, diferentes entidades
            pueden compartir información de manera ordenada, interoperable y
            coherente.
          </p>
          <p data-id="element-340" data-mp="3nacf5isfwxat">
            En términos simples, los OTL permiten que la información ambiental y
            la información catastral "conversen" entre sí. Gracias a este
            avance, Colombia se ha convertido en el primer país de Latinoamérica
            en desarrollar OTL ambientales diseñados para interoperar con el
            Catastro Multipropósito.
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.2
    }} data-id="element-341" data-mp="1zctr5n5huo84">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-342" data-mp="296kbqgyi2eij">
          Relación con el SIAC
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed text-sm" data-id="element-343" data-mp="1lgq0g3ttwy0e">
          <p data-id="element-344" data-mp="1ghwoifu6xf2c">
            Los OTL fortalecen la información disponible para el Sistema de
            Información Ambiental de Colombia (SIAC), al aportar datos
            estructurados sobre figuras ambientales y áreas geográficas
            delimitadas con efectos jurídicos. Su incorporación facilita que la
            información pueda ser consultada, compartida y aprovechada por
            distintos usuarios.
          </p>
          <p data-id="element-345" data-mp="1bcb14o172h26">
            Esta relación es importante porque el SIAC cumple un papel
            articulador en la gestión de la información ambiental del país. Los
            OTL contribuyen a mejorar la calidad, organización y disponibilidad
            de esa información para apoyar la toma de decisiones.
          </p>
          <p data-id="element-346" data-mp="1pcvg193znsqe">
            El{' '}
            <a href="https://datos.siac.gov.co/" target="_blank" rel="noopener noreferrer" className="text-clay font-medium hover:text-forest transition-colors inline-flex items-center gap-1" data-id="element-347" data-mp="1p9prpw36ouvq">
              Portal de Datos Abiertos del SIAC
              <ArrowUpRight size={14} className="flex-none" data-id="element-348" data-mp="2406txhnn7oto" />
            </a>{' '}
            reúne el repositorio de recursos y herramientas ambientales del
            país, donde esta información puede consultarse y descargarse de
            forma libre.
          </p>
        </div>
      </motion.div>
    </div>;
}